import * as Tgcc from '../tgccGlobal';
import * as React from 'react';
import Radium, { StyleRoot } from 'radium';
import {CSSProperties} from 'react';
import {connect} from 'react-redux';


const wrapperStyle : CSSProperties = {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    margin: '5px',
    height:'255px',
    cursor:'pointer',
     '@media (max-width:800px) and (max-height:1280px)': {
        margin:'10px auto'
    },
    '@media (max-width:768px) and (max-height:1366px)': {
        margin:'10px auto'
    },
    '@media (max-width:768px) and (max-height:1024px)': {
        margin:'10px auto'
    },
    '@media (max-width:414px)': {
        margin:'auto auto 10px auto'
    }
};

const contentStyle : CSSProperties = {
    height: '200px',
    width: '200px',
};
const logoStyle: CSSProperties = {
    width:'100%',
    height:'100%'
}
const schoolName: CSSProperties = {
    textAlign:'center',
    color:'rgb(97, 96, 96)',
    fontFamily:'BarlowLight'
}
class MerchProps{
    theme: Tgcc.MerchandisingTheme;
    onSelect?: (theme : Tgcc.MerchandisingTheme) => void;
}

class _MerchComponent extends React.Component<MerchProps,any> {

    handleSelection = (evt) => {
        if (this.props.onSelect){
            this.props.onSelect(this.props.theme);
        }
    }

    handleImageError = (event: React.SyntheticEvent<HTMLImageElement>) => {
        event.currentTarget.src = Tgcc.Styles.missingProductImageSrc;
    }



    render() {
        return (
            <div style={wrapperStyle}>
                <div style={contentStyle} onClick={this.handleSelection}>
                    <img src={Tgcc.getMerchLogo(this.props.theme.image)} style={logoStyle}/>
                    <div style={schoolName}>{this.props.theme.title}</div>
                </div>
            </div>
        )
    }
}
export var MerchComponent = Radium(_MerchComponent);
